import React, { useState, useEffect } from 'react';
import FaqAddItem from './FaqAddItem';
import FaqList from './FaqList';
import { useMode } from '../contexts/ModeContext';
import { Modal, Button } from 'react-bootstrap';

const Faqs = () => {
    const [refreshList, setRefreshList] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { isModeAdmin } = useMode();

    const handleAddItem = () => {
        setRefreshList(!refreshList);
        setShowModal(false);
    };

    useEffect(() => {
        setRefreshList(false);
    }, [isModeAdmin]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>
            { isModeAdmin && (
                <>
                    <Button variant="primary" onClick={() => setShowModal(true)}>Ajouter une question</Button>
                    <Modal show={showModal} onHide={handleCloseModal} size='xl'>
                        <Modal.Header closeButton>
                            <Modal.Title>Ajouter une question</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FaqAddItem handleAddItem={handleAddItem} />
                        </Modal.Body>
                    </Modal>
                </>
            )}
            <FaqList refreshList={refreshList}/>
        </>
    );
}

export default Faqs;
